export default [
    {
        priority: 9,
        path: "knowledge",
        menu: { title: "zhiji.menu.knowledge", icon: "el-icon-s-management", i18n: true },
        name: "knowledge",
        component: () => import("@/views/zhiji/pages/ServicePage.vue"),
        children: [
            {
                path: "questionlist",
                permit: "knowledge.fqamanager",
                menu: { title: "zhiji.menu.questionManager", i18n: true },
                name: "questionlist",
                component: () => import("@/views/zhiji/pages/knowlege/QuestionListPage.vue")
            },
            {
                path: "firstrecom",
                permit: "knowledge.firstscreen",
                menu: { title: "zhiji.menu.firstRecom", i18n: true },
                name: "firstrecom",
                component: () => import("@/views/zhiji/pages/firstrecom/FirstRecommend.vue")
            },
            {
                path: "wikipagesetting",
                permit: "knowledge.wikipage",
                menu: { title: "zhiji.menu.wiki", i18n: true },
                name: "wikipagesetting",
                component: () => import("@/views/zhiji/pages/wikiPage/WikiPage.vue")
            },
            {
                path: "cluster",
                menu: { title: "zhiji.menu.questionCluster", i18n: true },
                permit: "knowledge.questioncluster",
                name: "cluster",
                component: () => import("@/views/zhiji/pages/cluster/QuestionClusterPage.vue")
            },
            {
                path: "picture",
                menu: { title: "zhiji.menu.picture", i18n: true },
                permit: "knowledge.pictures",
                name: "picture",
                component: () => import("@/views/zhiji/pages/picture/PictureLibraryPage.vue")
            },
            {
                path: "video",
                menu: { title: "zhiji.menu.video", i18n: true },
                permit: "knowledge.videos",
                name: "video",
                component: () => import("@/views/zhiji/pages/video/VideoLibraryPage.vue")
            },
            {
                path: "guides",
                menu: { title: "zhiji.menu.guides", i18n: true },
                permit: "knowledge.tips",
                name: "guides",
                component: () => import("@/views/zhiji/pages/guides/GuidesLibraryPage.vue")
            }
        ]
    }
];

export const serviceData = {
    path: "zhijiservice",
    component: () => import("@/views/zhiji/pages/ServicePage.vue"),
    children: [
        {
            path: "serviceData",
            menu: { title: "zhiji.menu.serviceData", i18n: true },
            permit: "analytics.summary",
            name: "serviceData",
            component: () => import("@/views/zhiji/pages/serviceData/serviceDataPage.vue")
        }
    ]
};

export const robotDialogLog = {
    path: "zhijiservice",
    component: () => import("@/views/zhiji/pages/ServicePage.vue"),
    children: [
        {
            path: "robotDialogLog",
            menu: { title: "zhiji.menu.robotLog", i18n: true },
            permit: "analytics.robotanswer",
            name: "robotDialogLog",
            component: () => import("@/views/zhiji/pages/robotDialogLog/AskAnswerLogPage.vue")
        }
    ]
};

export const dataOverviewRobot = {
    path: "zhijiservice",
    component: () => import("@/views/zhiji/pages/ServicePage.vue"),
    children: [
        {
            path: "robot",
            menu: { title: "zhiji.menu.robot", i18n: true },
            permit: "overview.robot",
            name: "robot",
            component: () => import("@/views/zhiji/pages/dataOverview/DataOverviewPage.vue")
        }
    ]
};

export const robotHotAnalysis = {
    path: "zhijiservice",
    component: () => import("@/views/zhiji/pages/ServicePage.vue"),
    children: [
        {
            path: "hotSpotAnaly",
            menu: { title: "zhiji.menu.hotSpotAnaly", i18n: true },
            name: "hotSpotAnaly",
            permit: "analytics.robotanalysis",
            component: () => import("@/views/zhiji/pages/hotSpotAnaly/HotSpotAnalysis.vue")
        }
    ]
};

export const robotSatisfaction = {
    path: "zhijiservice",
    component: () => import("@/views/zhiji/pages/ServicePage.vue"),
    children: [
        {
            path: "satisfaction",
            menu: { title: "zhiji.menu.satisfaction", i18n: true },
            permit: "analytics.robotsatisf",
            name: "satisfaction",
            component: () => import("@/views/zhiji/pages/satisfaction/Satisfaction.vue")
        }
    ]
};

export const robotForm = {
    path: "zhijiservice",
    component: () => import("@/views/zhiji/pages/ServicePage.vue"),
    children: [
        {
            path: "formManager",
            permit: "system.formmanager",
            menu: { title: "zhiji.menu.formManager", i18n: true },
            name: "formManager",
            component: () => import("@/views/zhiji/pages/form/FormManagePage.vue")
        }
    ]
};

export const robotUser = {
    path: "zhijiservice",
    component: () => import("@/views/zhiji/pages/ServicePage.vue"),
    children: [
        {
            path: "userManager",
            permit: "system.usermanager",
            menu: { title: "zhiji.menu.userManager", i18n: true },
            name: "userManager",
            component: () => import("@/views/zhiji/pages/personnel/PersonManagePage.vue")
        }
    ]
};

export const robotPortrait = {
    path: "zhijiservice",
    component: () => import("@/views/zhiji/pages/ServicePage.vue"),
    children: [
        {
            path: "portraitConfig",
            permit: "system.portraitconfig",
            menu: { title: "zhiji.menu.portraitConfig", i18n: true },
            name: "portraitConfig",
            component: () => import("@/views/zhiji/pages/portraitConfig/AnswerSettingPage.vue")
        }
    ]
};

export const robotSensitive = {
    path: "zhijiservice",
    component: () => import("@/views/zhiji/pages/ServicePage.vue"),
    children: [
        {
            path: "sensitiveWord",
            menu: { title: "zhiji.menu.sensitiveWord", i18n: true },
            permit: "system.sensitiveword",
            name: "sensitiveWord",
            component: () => import("@/views/zhiji/pages/sensitiveWord/SensitiveWordManage.vue")
        }
    ]
};

export const robotMonitor = {
    path: "zhijiservice",
    component: () => import("@/views/zhiji/pages/ServicePage.vue"),
    children: [
        {
            path: "robotMonitor",
            menu: { title: "zhiji.menu.robotMonitor", i18n: true },
            permit: "monitor.robot",
            name: "robotMonitor",
            component: () => import("@/views/zhiji/pages/robotMonitor/RobotMonitorPage.vue")
        }
    ]
};

export const businessSetting = {
    path: "businesssetting",
    menu: { title: "zhiji.menu.businessSet", i18n: true },
    permit: "business.settings",
    name: "businesssetting",
    component: () => import("@/views/zhiji/pages/businessSetting/Page.vue")
};

export const moduleSetting = {
    path: "modulesetting",
    menu: { title: "zhiji.menu.moduleSet", i18n: true },
    permit: "admin.moduleconfig",
    name: "modulesetting",
    component: () => import("@/views/zhiji/pages/moduleSetting/Page.vue")
};
